import './PublicApp.css'
import DataLink from '../../icons/DataLink.svg?react';
import MikeTopbar from '../mike-topbar/mike-topbar';
import MikeSupportMenuContainer from '../mike-support';
import MikeSubscribedApps from '../mike-subscribed-apps';
import AppBreadcrumpsNav from '../AppBreadcrumpsNav';
import { GlobalContext } from '../../store/Store';
import * as React from 'react';
import { useState, useContext, useEffect } from 'react';
import ai from '../../telemetry';
import { Route, Routes, useNavigate, } from 'react-router-dom';
import  ActionType from '../../store/ActionType';
import MikeSnackbar from '../mike-snackbar';
import { IGlobalContext } from './AppWrapper';
import AppSpinners from './AppSpinners';
import fetchConfig from '../../apis/config';
import MikeNotificationContainer from '../mike-notification-list';
import { messaType2MikeSnackbarType } from '../../store/messageReducer';
import {
  IApplications,
  IApplication,
} from '../mike-subscribed-apps/model/IApplications';
import MikeLogin from './login';
import LandingPage from './login/LandingPage';
import { useOidc, useOidcIdToken } from '@axa-fr/react-oidc';
import { IUser } from '../../Models/User';
import { PlatformProxy } from '../../apis/PlatformProxy';
import { IFeature } from '../../Models/Feature';
import { AppConfig } from '../../Models/AppConfig';
import AuthenticationCallback from './login/AuthenticationCallback';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { getExtractionBuilder, getListMeshStatus, getMeshBoundariesForLastMesh, getTileGridConfig } from './apiFunctions';
import MikeHomeButton from '../mike-home-button';
import ProjectsPage from '../../pages/ProjectsPage';
import Grid from '@mui/material/Grid';
import MapPage from '../../pages/MapPage';
import { TPanelId } from '../SidePanel/SidePanel';
import FoldersPage from '../../pages/FoldersPage';

function App() {
  const { isAuthenticated, login } = useOidc();
  const { idToken, idTokenPayload } = useOidcIdToken();
  const { search, pathname } = useLocation();
  const navigate = useNavigate()

  const [initialized, setInitialized] = useState(false);
  const [mapMeshLoaded, setMapMeshLoaded] = useState(false);
  // const [redirectRoute, setRedirectRoute] = useState(false);
  const [initialSidePanelTab, setInitialSidePanelTab] = useState('upload-panel');

  // global store
  const [globalState, globalDispatch] = useContext(GlobalContext);
  const globalContext: IGlobalContext = { state: globalState, dispatch: globalDispatch };
  const currentProject = globalState.project && globalState.project.currentProject;
  const user = globalState.auth && globalState.auth.user ? globalState.auth.user : null;

  useEffect(() => {
    if (document.location.hostname.endsWith('mike-cloud.com')) {
      const _paq = ((window as any)._paq = (window as any)._paq || []);
      /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
      _paq.push(['setDocumentTitle', document.location.hostname + '/' + document.title]);
      _paq.push(['setCookieDomain', document.location.hostname]);
      _paq.push(['setDomains', [document.location.hostname]]);
      _paq.push(['trackPageView']);
      _paq.push(['enableLinkTracking']);
      const u = 'https://dhigroup.matomo.cloud/';
      _paq.push(['setTrackerUrl', u + 'matomo.php']);
      _paq.push(['setSiteId', '8']);
      const d = document;
      const g = d.createElement('script');
      const s = d.getElementsByTagName('script')[0];
      g.async = true;
      g.src = '//cdn.matomo.cloud/dhigroup.matomo.cloud/matomo.js';
      if (s && s.parentNode) {
        s.parentNode.insertBefore(g, s);
      }
    }
  }, []);

  useEffect(() => { 
    function getUserProfile(userData: any) {
      const user: IUser = {
        id: userData.oid,
        tenantId: userData.TenantId,
        tenantName: userData.TenantName,
        name: userData.sub,
        initials: userData.sub
          .split(' ')
          .map(n => n[0])
          .join(''),
        email: userData.email,
        roles: userData['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']
          ? [userData['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']]
          : [],
      };
      return user;
    }
    if (idToken) {
      const userProfile = getUserProfile(idTokenPayload);
      globalDispatch({ type: ActionType.SET_USER, data: userProfile });
      // getConfig();
    }
  }, [idToken, idTokenPayload]);

  useEffect(() => {
    async function getConfig() {
      try {
        const response = await fetchConfig();
        if (response) {
          globalDispatch({ type: ActionType.SET_CONFIG, data: response });
          setInitialized(true);
        }
      } catch (e) {
        console.log('Error: ', e.message);
        console.log('app config not gotten');
      }
    }
    if (isAuthenticated){
      getConfig();
    }    
  }, [isAuthenticated]);

  useEffect(() => {
    if (user) {
      if (search) {
        const pathAndSearch = search.length > 1 ? pathname + search : pathname;
        const parameters = qs.parse(search.replace('?', '')) || {};
        if (parameters.tenantId && parameters.tenantId !== user.tenantId) {
          const extras = {
            prompt: 'none',
            tenantId: parameters.tenantId.toString(),
          };
          login(pathAndSearch, extras);
        }
      }
    }
  }, [user, login, search, pathname]);

  useEffect(() => {
    async function getIsUserRootContributor(tenantId: string) {
      let isContributor = false
      try {
        const response = await PlatformProxy.getCapabilities(tenantId);       
        if (response && response.data && response.data.canCreateContent && response.data.canCreateContent === true) {
          isContributor = true           
        }
      } catch (e) {
        console.log('Error: ', e.message);
        console.log('app config not gotten');
      }
      globalDispatch({ type: ActionType.SET_IS_USER_ROOT_CONTRIBUTER, data: isContributor });   
    }
    if (user) {
      const _paq = (window._paq = window._paq || []);
      _paq.push(['setUserId', user.email]);
      _paq.push(['trackPageView']);
      _paq.push(['enableHeartBeatTimer']);
      if (user.tenantId){
        getIsUserRootContributor(user.tenantId)
      }
    }
  }, [user]);

  useEffect(() => {
    if (initialized && currentProject && currentProject.id) {
      getExtractionStatus();
      getTileGridStatus();
    }
  }, [globalState.mesh?.meshName]);

  const onNavigateToProjectList = () => {
    // console.log('navigating back to project list, reset selectedProject...');
    setMapMeshLoaded(false);
    // setRedirectRoute(true);
    globalDispatch({
      type: ActionType.SET_CURRENT_PROJECT_AND_PATH,
      data: { project: null, path: [] },
    });
    globalDispatch({ type: ActionType.SET_DATA_EXTRACTION_BUILDER, data: null });
    globalDispatch({ type: ActionType.SET_MESH_NAME, data: '' });
    globalDispatch({ type: ActionType.SET_MESH_FEATURES, data: null });
    globalDispatch({ type: ActionType.SET_MESH_PROJECTION, data: null });
    globalDispatch({ type: ActionType.SET_MESH_TILEGRID_CONFIG, data: null });
    navigate("/")
  };

  const onProjectSelected = function() {
    setMapMeshLoaded(false);
  };

  const onProjectInBreadcrumpSelected = () => {
    setMapMeshLoaded(false);
  };  

  const getExtractionStatus = async () => {
    getExtractionBuilder({
      meshName: globalState.mesh && globalState.mesh.meshName ? globalState.mesh.meshName : '',
      projectID: currentProject && currentProject.id ? currentProject.id : '',
      modelType: globalState.mesh && globalState.mesh.modelType ? globalState.mesh.modelType : '',
      globalDispatch,
    });
  };

  const getTileGridStatus = async () => {
    getTileGridConfig({
      meshName: globalState.mesh && globalState.mesh.meshName ? globalState.mesh.meshName : '',
      projectID: currentProject && currentProject.id ? currentProject.id : '',
      globalContext,
    });
  };

  useEffect(() => {
    // When current project changed and map is loaded
    // To avoid current project getting stale, this needs to be called in a useEffect
    if (!mapMeshLoaded) {
      // load mesh maps here
      if (currentProject && globalState.map && (globalState.map as any).olMap) {
        getListMeshStatus({ globalContext }).then(response => {
          // console.log('App getMeshStatus.then: response', response);
          if (!response || !response.data || response.data.length < 1) {
            setInitialSidePanelTab('upload-panel');
            return;
          }
          setInitialSidePanelTab('boundaries');
          getMeshBoundariesForLastMesh({
            meshFiles: response.data,
            // globalDispatch,globalState,
            globalContext,
          });
        });
        setMapMeshLoaded(true);
      }
    }
  }, [currentProject, mapMeshLoaded]);

  // End of Login functions ------------------------------------------------------------------------------------------------- //

  const appConfig = globalState.auth?.appConfig;

  if (appConfig && appConfig.applicationInsightsKey && !ai.appInsights) {
    ai.initialize(appConfig.applicationInsightsKey);
  }

  const [apps, setApps] = useState<IApplications | null>(null);
  const [appsLoading, setAppsLoading] = useState<boolean>(false);

  useEffect(() => {
    async function getTenants() {
      try {
        const response = await PlatformProxy.getUserTenants();
        if (response && response.data) {
          globalDispatch({ type: ActionType.SET_TEANANTS, data: response.data });
          setInitialized(true);
        }
      } catch (e) {
        console.log('Error: ', e.message);
        console.log('app config not gotten');
      }
    }

   

    async function getApplications(appConfig: AppConfig) {
      try {
        const response = await PlatformProxy.getApplications();
        if (!response || !response.data || !response.data.data || response.data.data.length < 1) {
          return;
        }
        const features: IFeature[] = response.data.data;
        let apps = new Array<IApplication>();
        if (features && features.length > 0) {
          let ownFeatureId = '7305229f-a918-ed11-b83e-002248818425';
          if (!process.env.NODE_ENV) {
            if (appConfig.clientName) {
              ownFeatureId = appConfig.clientName;
            }
          }
          apps = features
            .filter(
              (app: IFeature) =>
                app.enabled &&
                app.url &&
                app.type === 'Application' &&
                app.featureId !== ownFeatureId
            )
            .map((app: IFeature) => {
              return {
                appName: app.name,
                forAdministratorOnly: false,
                appUrl: app.url.endsWith('/') ? app.url : app.url + '/',
                iconName: app.name,
              };
            });
        }

        const applications: IApplications = {
          administrationApps: new Array<IApplication>(),
          appsInSubscription: apps,
          appsOutsideSubscription: new Array<IApplication>(),
        };
        setApps(applications);
        setAppsLoading(false);
      } catch (e) {
        console.log('Error: ', e.message);
        console.log('app config not gotten');
      }
    }

    if (isAuthenticated && appConfig) {
      getTenants();
      getApplications(appConfig);
    }
  }, [isAuthenticated, appConfig]);

  // TopBar CallBacks

  const getAppIcon = () => {
    return <DataLink />;
  };
  const getHomeButton = () => {
    return (    
      <MikeHomeButton        
        hrefLink={
          appConfig && appConfig.dataAdminUri
            ? appConfig.dataAdminUri + '?tenantId=' + user?.tenantId
            : ''
        }
        tooltipTitle="MIKE Cloud Home"
        tooltipArrow={true}
      />  
    );
  };
  const getLoginButton = () => {
    return (      
      <MikeLogin />    
    );
  };
  const mailConfig = {
    to:
      appConfig && appConfig.support && appConfig.support.supportEmail
        ? appConfig.support.supportEmail
        : '',
    subject:
      appConfig && appConfig.support && appConfig.support.supportSubject
        ? appConfig.support.supportSubject
        : '',
    body:
      appConfig && appConfig.support && appConfig.support.supportBody
        ? appConfig.support.supportBody
        : '',
  };

  const documentationConfig = {
    href:
      appConfig && appConfig.support && appConfig.support.supportLinksDocumentation
        ? appConfig.support.supportLinksDocumentation
        : '',
    label: 'Data Link User guide',
    target: '_blank',
  };

  const exampleDataConfig = {
    href: appConfig && appConfig.dataLinkExampleData ? appConfig.dataLinkExampleData : '',
    label: 'Download example file',
    target: '_blank',
  };

  const getSupportButton = () => {
    return (
      <MikeSupportMenuContainer
        documentationConfig={[documentationConfig, exampleDataConfig]}
        mailConfig={mailConfig}
      />
    );
  };

  const breadcrumpsContent =
    globalState.project && globalState.project.currentProjectPath
      ? globalState.project.currentProjectPath
      : [];
  const getBreadcrumpsWithFolderSupport = () => {
    return (
      <AppBreadcrumpsNav
        breadcrumpsContent={breadcrumpsContent}
        onClickCallBack={onProjectInBreadcrumpSelected}
        onRootClickCallback={onNavigateToProjectList}       
      />
    );
  };

  const onSnackbarAction = () => {
    globalDispatch({ type: ActionType.SET_SHOW_MESSAGE, show: false });
    globalDispatch({ type: ActionType.SET_MESSAGE, message: '' });
    // Test code for message to remain:
    // globalDispatch({ type: ActionType.SET_SHOW_MESSAGE, show: true });
    // globalDispatch({ type: ActionType.SET_MESSAGE, message: '[DUMMY MESSAGE]' });
  };
  const onSnacbkarClose = (_event: React.SyntheticEvent | React.MouseEvent, reason?: string) => {
    if (reason !== 'clickaway') onSnackbarAction();
  };

  const onHandleNotificationClickAway = () => {
    globalDispatch({ type: ActionType.HIDE_NOTIFICATION_DOT });
  };

  const getSubscribedApps = () => {
    const tenantId = user ? user.tenantId : '';
    return (
      <MikeSubscribedApps
        currentAppName={'Data Link'}
        applications={apps}
        projectId={
          globalState.project &&
          globalState.project.currentProject &&
          globalState.project.currentProject.projectGuid
            ? globalState.project.currentProject.projectGuid
            : ''
        }
        loading={appsLoading}
        tenantId={tenantId}
      />
    );
  };

  return isAuthenticated ? (
    <div className="App">
      <div className="fixBoxSizing">
        <MikeTopbar
          appIcon={getAppIcon()}
          homeButton={getHomeButton()}
          loginButton={getLoginButton()}
          supportButton={getSupportButton()}
          breadcrump={
            globalState.project?.currentProject &&
            globalState.project.currentProject.name &&
            getBreadcrumpsWithFolderSupport()
          }
          alertArea={
            globalState.project &&
            globalState.project.currentProject && (
              <MikeNotificationContainer
                showDot={
                  globalState.notification && globalState.notification.showNotificationDot
                    ? globalState.notification.showNotificationDot
                    : false
                }
                notifications={
                  globalState.notification &&
                  globalState.notification.notifications &&
                  globalState.notification.notifications[
                    globalState.project.currentProject.projectGuid
                  ]
                }
                href={
                  appConfig &&
                  appConfig.dataAdminUri +
                    appConfig.dataAdminProjectPage +
                    globalState.project.currentProject.projectGuid +
                    '?tenantId=' +
                    user?.tenantId
                }
                clickAwayCallback={onHandleNotificationClickAway}             
              />
            )
          }
          appTitle="Data Link"
          actionsArea={globalState.project && globalState.project.currentProject && <AppSpinners />}
          appsDropdown={
            globalState.project && globalState.project.currentProject && getSubscribedApps()
          }
          style={{ zIndex: 1250 }}
        />
      </div>

      {/* {redirectRoute === true ? <Redirect to="/" /> : ''} */}

     <Grid container direction="column" className="App-content">  
      <Routes>
        <Route path="/authentication/callback" element={<AuthenticationCallback/>} />         
          <Route path="/map" element={<MapPage initialSidePanelTab={initialSidePanelTab as TPanelId} />} />
          <Route
            path="/project/:id"            
            element={<FoldersPage onProjectSelectedCallback={onProjectSelected} />} 
          />
          <Route
            path="/"            
            element={<ProjectsPage onProjectSelectedCallback={onProjectSelected} />} 
          />         
       </Routes>  
      </Grid>
     
      <MikeSnackbar
        open={
          globalState.message && globalState.message.showMessage
            ? globalState.message.showMessage
            : false
        }
        mikeSnackbarType={messaType2MikeSnackbarType(
          globalState.message && globalState.message.messagetype
            ? globalState.message.messagetype
            : 'info'
        )}
        message={globalState.message?.message}
        action={'OK'}
        onClose={onSnacbkarClose}
        mikeOnAction={onSnackbarAction}
        autoHideDuration={
          globalState.message && globalState.message.messagetype === 'error' ? null : 4000
        }
      />
    </div>
  ) : (
    <LandingPage />
  );
}

export default App;
